import React from 'react'
import '.././popup.common.css'
import styles from './Style.module.css'
import CustomModal from '../../Modal/CustomModal'
import BorderedButton from '../../Buttons/BorderedButton'
import PrimaryButton from '../../Buttons/PrimaryButton'

const DeleteConfirmPopup = ({ onCancel, onConfirm, title, message, isDeleting, showCloseOnly, from="" ,deleteGuestName=null}) => {
  return (
    <CustomModal
      show={true}
      onHide={onCancel}
      hideCloseButton={true}
    >
      <div className={`popup ${styles.deletePopup}`}>
        <div className="header">
          <h2>{title || 'Delete Client'}</h2>
        </div>

        {from==="checkin-report" ? (
          <div className="body">
            <p className={styles.deleteMessage}>
              Are you sure you want to delete the check-in for <span className={styles.deleteGuestName}>{deleteGuestName}?</span> This action cannot be undone.
            </p>
          </div>
        ) : (
          <div className="body">
          <p className={styles.deleteMessage}>
              {message || 'Are you sure you want to delete this client? This action cannot be undone.'}
            </p>
          </div>
        )}

        <div className="footer">
          {showCloseOnly ? (
            <BorderedButton
              text="Close"
              onClick={onCancel}
            />
          ) : (
            <>
              <BorderedButton
                text="Cancel"
                onClick={onCancel}
                disabled={isDeleting}
              />
              <PrimaryButton
                text={isDeleting ? 'Deleting...' : 'Delete'}
                onClick={onConfirm}
                disabled={isDeleting}
                className={styles.deleteButton}
              />
            </>
          )}
        </div>
      </div>
    </CustomModal>
  )
}

export default DeleteConfirmPopup

